import React, { Fragment, useEffect, useRef, useState, useContext } from "react";
import styles from './index.module.scss'
import accountApi from "../../api/accountApi";
import orderApi from '../../api/orderApi';
import { Row, Spin, Col, Select, Input, Modal, Button } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { strEncrypt, getDecryptParams } from '../../utils/utils'
import { useIntl } from 'react-intl'
// import { Supplement } from '../Mine/Company'
import MainContext from '../../stores/stores'
import { useAliveController } from 'react-activation'
import listApi from "@/api/listApi";


const Hmcarsearch: React.FC<any> = (props) => {

  

  const { setCarInfo, setOpen, isexport }  = props
  const navigate = useNavigate()
  const { refreshScope, clear, dropScope, drop, refresh  } = useAliveController()

  const [searchParams, setSearchParams] = useSearchParams()
  let params1 = searchParams.get('params')
  const intl = useIntl()
  const { commonStore, setCommonStore } = useContext(MainContext)
  const { colorPrimary, fontColorPrimary  } = commonStore
  const [activeAcronym, setActiveAcronym] = useState<string>('all')
  const [brandLoading, setBrandLoading] = useState<boolean>(false)
  const [brandData, setBrandData] = useState<any>({
    acronyms: [],
    brands: []
  })
  const [searchKey, setSearchKey] = useState<any>("")
  const [modelLoading, setModelLoading] = useState<boolean>(false)
  const [activeBrand, setActiveBrand] = useState<any>({})
  


  const [selectType, setSelectType] = useState<any>('')
  const [selectArr, setSelectArr] = useState<any>([])
  const [selectList, setSelectList] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(false)

  
  const [keyword, setKeyword] = useState<string>("")
  const [supplementOpen, setSupplementOpen] = useState<boolean>(false)
  const [companyInfo, setCompanyInfo] = useState<any>({})
	
	const [passLoading, setPassLoading] = useState<boolean>(false)

  const [isFirst, setIsFirst] = useState<boolean>(false)
  const attrKeys = ['brand', 'series', 'chassis_code', 'models', 'produced_year', 'displacement', 'engine_model', 'transmission_description', 'drive_mode']
  const attrObj: any = {
    series: intl.formatMessage({ id: '车系' }),
    chassis_code: intl.formatMessage({ id: '底盘号' }),
    models: intl.formatMessage({ id: '车型' }),
    produced_year: intl.formatMessage({ id: '年份' }),
    displacement: intl.formatMessage({ id: '排量' }),
    engine_model: intl.formatMessage({ id: '发动机代码' }),
    transmission_description: intl.formatMessage({ id: '变速箱类型' }),
    drive_mode: intl.formatMessage({ id: '驱动方式' })
  }

  const [selectObj, setSelectObj] = useState<any>({
    series: [],
    chassis_code: [],
    models: [],
    produced_year: [],
    displacement: [],
    engine_model: [],
    transmission_description: [],
    drive_mode: []
  })
  const [selectOptions, setSelectOptions] = useState<any>({
    series: [],
    chassis_code: [],
    models: [],
    produced_year: [],
    displacement: [],
    engine_model: [],
    transmission_description: [],
    drive_mode: []
  })
  const [clickKey, setClickKey] = useState("")
  const [filterSearch, setFilterSearch] = useState<any>({
    series: '',
    chassis_code: ''
  })

  const [change, setChange] = useState<boolean>(false)

  useEffect(() => {
    getSelectBrandList()
  },[])

  
  useEffect(() => {
    
    if(props.carInfo && props.carInfo.brandCode && brandData.brands && brandData.brands.length && props.carInfo.brandCode !== activeBrand.brandCode) {
      setSelectArr([])
      brandData.brands.forEach((item: any) => {
        item.brands.forEach((it: any) => {
          if(it.brandCode === props.carInfo.brandCode) {
            setActiveBrand(it)
            setSearchKey(it.key)
          }
        })
      })
    }
    if(props.carInfo && !props.carInfo.brandCode) {
      setActiveBrand({})
    }
  }, [brandData, props.carInfo])

  useEffect(() => {
    /* if(props.carInfo && props.carInfo.brand && selectArr.length && !isFirst) {
      let carInfoKeys = Object.keys(props.carInfo)
      let carInfoArr = carInfoKeys.filter((key: any) => key !== 'brand_img' && key !== 'cars_id' && key !== 'brandCode' && key !== 'code' && key !== 'brand_logo' && key !== 'market_name')
      let carInfoLength = carInfoArr.length
      let selectArrLength = selectArr.length
      let indexs = selectArr.length - 1
      let selectArrLastItem = selectArr[indexs]
      console.log("selectArrLength:", selectArrLength, "carInfoLength:", carInfoLength, "selectArrLastItem:", selectArrLastItem)
      if((selectArrLength <= carInfoLength - 2 && !selectArrLastItem.title) || selectArrLength < carInfoLength - 3) {
        let selectArrLastList = selectArrLastItem.list
        let _selectType = selectArrLastItem.key
        let carInfoIndex = carInfoKeys.indexOf(_selectType)
        if(carInfoIndex > -1) {
          let selectValue = props.carInfo[_selectType]
          let index = selectArrLastList.findIndex((item: any) => item[_selectType] === selectValue)
          if(index > -1) {
            let item = selectArrLastList[index]
            tonext(item, indexs, false)
          }
        }
      }
    } */
    // if(props.carInfo && props.carInfo.brand && selectArr.length && !isFirst) {
    //   let carInfoKeys = Object.keys(props.carInfo)
    //   let carInfoArr = carInfoKeys.filter((key: any) => key !== 'brand_img' && key !== 'cars_id' && key !== 'brandCode' && key !== 'code' && key !== 'brand_logo' && key !== 'market_name')
    //   let carInfoLength = carInfoArr.length
    //   let selectArrLength = selectArr.length
    //   let indexs = selectArr.length - 1
    //   let selectArrLastItem = selectArr[indexs]
    //   console.log("selectArrLength:", selectArrLength, "carInfoLength:", carInfoLength, "selectArrLastItem:", selectArrLastItem)
    //   if((selectArrLength <= carInfoLength - 1 && !selectArrLastItem.title) || selectArrLength < carInfoLength - 2) {
    //     let selectArrLastList = selectArrLastItem.list
    //     let _selectType = selectArrLastItem.key
    //     let carInfoIndex = carInfoKeys.indexOf(_selectType)
    //     if(carInfoIndex > -1) {
    //       let selectValue = props.carInfo[_selectType]
    //       let index = selectArrLastList.findIndex((item: any) => item[_selectType] === selectValue)
    //       if(index > -1) {
    //         let item = selectArrLastList[index]
    //         tonext(item, indexs, false)
    //       }
    //     }
    //   }
    // }
  }, [selectType, isFirst])

  useEffect(() => {
    if(activeBrand.brandCode) {
      console.log(clickKey)
      setClickKey('brand')
    }else {
      
    }
  },[activeBrand, searchKey])

  useEffect(() => {
    if(clickKey) {
      getAttrData()
    }
  }, [clickKey, selectObj])

  useEffect(() => {
    if(clickKey === 'drive_mode') newPass()
  },[clickKey])


  const getAttrData = () => {
    let i = attrKeys.indexOf(clickKey)

    let key = attrKeys[i + 1]
    if(key === 'chassis_code') {
      setFilterSearch({...filterSearch, chassis_code: ''})
      setKeyword('')
    }
    if(!key) return false
    let params: any = {
      brand: [activeBrand.brand_name],
      attribute: key,
    }
    Object.keys(selectObj).forEach((ikey: any) => {
      if(selectObj[ikey] && selectObj[ikey].length) {
        params[ikey] = selectObj[ikey]
      }
    })
    setLoading(true)
    listApi.getAttrData(params).then((res: any) => {
      setLoading(false)
      if(res.code === 1) {
        let _selectOptions: any = JSON.parse(JSON.stringify(selectOptions))
        let newSelectOptions: any = {}
        let needAttr = attrKeys.slice(0, i + 1)
        needAttr.forEach((akey) => {
          newSelectOptions[akey] = _selectOptions[akey]
        })
        setSelectOptions({
          ...newSelectOptions,
          [key]: res.data
        })
      }
    })
  }
  console.log(activeBrand)
  

  const getSelectBrandList = () => {
    setBrandLoading(true)
    accountApi.getSelectBrandList().then((res: any) => {
      setBrandLoading(false)
      if(res.code === 1) {
        setBrandData(res.data.cars_brands.all_brands)
      }
    })
  }

  

  const selectBrand = (brand: any) => {
    setActiveBrand(brand); 
    setSearchKey(brand.key)
    setSelectType('brand')
  }

  
	
	



  const toSelect = (key: string, value: any) => {
    let _selectObj = JSON.parse(JSON.stringify(selectObj))
    let moreKeys = ['models', 'produced_year', 'chassis_code']
    if(key !== 'series') {
      let keyIndex = attrKeys.indexOf(key)
      let nextKey = attrKeys[keyIndex + 1]
      if(_selectObj[key] && _selectObj[key].length) {
        if(moreKeys.includes(key)) {
          if(_selectObj[key].includes(value)) {
            if(_selectObj[key].length !== 1) {
              let i = _selectObj[key].indexOf(value)
              _selectObj[key].splice(i, 1)
            }
          }else {
            _selectObj[key].push(value)
          }
        }else {
          _selectObj[key] = [value]
        }
        if(nextKey) {
          let delAttr = attrKeys.slice(keyIndex + 1, attrKeys.length)
          let _selectOptions = JSON.parse(JSON.stringify(selectOptions))
          delAttr.forEach((d) => {
            if(_selectObj[d]) delete _selectObj[d]
            if(_selectOptions[d]) delete _selectOptions[d]
          })
          setSelectOptions(_selectOptions)
        }

      }else {
        _selectObj[key] = [value]
      }
      if(nextKey) {
        let delAttr = attrKeys.slice(keyIndex + 1, attrKeys.length)
        let _selectOptions = JSON.parse(JSON.stringify(selectOptions))
        delAttr.forEach((d) => {
          if(_selectObj[d]) delete _selectObj[d]
          if(_selectOptions[d]) delete _selectOptions[d]
        })
        setSelectOptions(_selectOptions)
      }
    }else {
      // series
      _selectObj = {'brand': selectObj.brand, [key]: [value]}
      setSelectOptions({[key]: selectOptions[key]})
    }
    setClickKey(key)
    setSelectObj(_selectObj)
    
  }

  const reset = () => {
    setActiveBrand({})
    setSelectObj({})
    setSelectOptions({})
    setClickKey("")
    setFilterSearch({
      series: '',
      chassis_code: ''
    })
  }
  const newPass = () => {
    console.log(activeBrand, activeBrand.brand_name)
    let params = {
      ...selectObj
    }
    params.brand = activeBrand.brand_name
    console.log(params)
    setPassLoading(true)
    listApi.getPartsCars(params).then((res: any) => {
      setPassLoading(false)
      if(res.code === 1) {
        let cars = res.data[0] ? res.data[0].cars : []
        let codeArr: any = []
        let market_name_arr: any = []
        cars.forEach((it: any) => {
          codeArr.push(it.code)
        })
        let newParams: any = {
          cars_id: codeArr.join(","),
          brandCode: activeBrand.brandCode,
        }
        attrKeys.forEach((key) => {
          if(params[key]) {
            if(key === 'brand') {
              newParams[key] = params[key]
            }else {
              newParams[key] = params[key].join(",")
            }
            market_name_arr.push(newParams[key])
          }
        })
        newParams['market_name'] = market_name_arr.join(">")
        setCarInfo(newParams)
        setOpen(false)
      }
    })
  }
  console.log(clickKey)
  return (
    <div className="flex-c-c">
      <div className="ptb10" style={{ width: setCarInfo ? '100%' : '90%', overflowX: 'scroll' }}>
        <div className={styles['carsearch'] +  ' plr10'} >
          {
            !activeBrand.brandCode ? (
              <Spin spinning={brandLoading} delay={1000} indicator={<img src="https://cdns.007vin.com/img/autorepair/cst/car_loading.gif"/>} wrapperClassName={styles['list-spin']}>  
                <div className={styles['acronyms'] + ' flex-s-c ptb10'}>
                  <span className="mr5">{intl.formatMessage({ id: '品牌' })}: </span>
                  {
                    ['all', ...brandData.acronyms].map((acronym: string) => {
                      return (<span onClick={() => setActiveAcronym(acronym)} className={styles['acronym'] + " " + `${activeAcronym === acronym ? styles['active'] : ''}`}>{acronym.toUpperCase()}</span>)
                    })
                  }
                </div>
                
                <div className={styles['brand-list']}>
                  {
                    brandData.brands.filter((_item: any) => (_item.acronyms === activeAcronym || activeAcronym === 'all')).map((item: any, index: number) => {
                      return item.brands.map((brand: any, i: number) => {
                        return (
                          <div key={'' + index + i} className={styles['brand']} onClick={() => {selectBrand(brand)}}>
                            <img src={brand.brand_img} alt="" />
                            <span>{brand.brand_name}</span>
                          </div>
                        )
                      })
                    })
                  }
                </div>
                </Spin>
              ): (
                <div className={styles['select']}>
                  <div className={styles['select-data'] + ' flex-s-c ptb5'}>
                    <img className="pointer" src={activeBrand.brand_img} onClick={() => reset()} />
                    <span className="mr5 pointer" onClick={() => reset()}>{intl.formatMessage({ id: '品牌' })}：{activeBrand.brand_name}</span>
                    {/* {
                      selectArr.filter((it: any) => it.title).map((item: any, index: number) => {
                        return <div key={index} ><span className="mlr5" >&gt;</span><span>{item.title}</span></div>
                      })
                    } */}
                    {
                      attrKeys.filter((it) => it !== 'brand').map((key) => {
                        if(selectObj[key] && selectObj[key].length) {
                          return (
                            <div>&gt;{selectObj[key].join(",")}</div>
                          )
                        }
                      })
                    }
                    <div className={styles['pass'] + ' flex-s-c'}>
                      {/* {
                        selectArr.length > 0 ?  : null
                      } */}
                      {
                        selectOptions['series'] && selectOptions['series'].length ? (
                          <Button size="small" style={{marginRight: 5, marginLeft: 5}} onClick={() => reset()}>{intl.formatMessage({id: '重置'})}</Button>
                        ): null
                      }
                      {
                        selectObj['series'] && selectObj['series'].length  ? (
                          <Button loading={passLoading} size="small" onClick={() => newPass()}>{intl.formatMessage(( {id: '跳过' } ))}</Button>
                        ): null
                      }
                    </div>
                    
                  </div>
                  <Spin spinning={loading} delay={1000} indicator={<img src="https://cdns.007vin.com/img/autorepair/cst/car_loading.gif"/>} wrapperClassName={styles['list-spin']}>
                    <div className={styles['select-option'] + ' flex-s-c'}>
                        

                        {
                          Object.keys(selectOptions).filter((k) => selectOptions[k] && selectOptions[k].length).map((key: string, keyindex: number) => {
                            let items = selectOptions[key]
                            let filterKeys = ['chassis_code']
                            return (
                              <div className="mr10" style={{ width: 220 }} key={keyindex}>
                                <div className={styles['title']}>{attrObj[key]}{key === 'models' || key === 'produced_year' || key === 'chassis_code' ? `(${intl.formatMessage({ id: '可多选' })})` : ''}</div>
                                {
                                  filterKeys.includes(key) ? (
                                    <Input.Search style={{ height: 30 }} allowClear placeholder={intl.formatMessage({ id: '搜索' })}  onSearch={(value) => setKeyword(value)} />
                                  ): null
                                }
                                <div className={styles['list']} style={{ overflow: 'scroll', height: `calc(100vh - ${filterKeys.includes(key) ? 270 : 240}px)` }}>
                                  {
                                    (items).map((item: any, index: number) => {
                                      if(!filterKeys.includes(key) || (keyword && item.toLocaleUpperCase().includes(keyword.toLocaleUpperCase())) || !keyword) {
                                        return (
                                          <div 
                                            className={styles['item'] + " " + `${selectObj[key] && selectObj[key].includes(item) ? styles['active'] : ''}`} 
                                            style={{background: selectObj[key] && selectObj[key].includes(item) ? colorPrimary : '#fff', color: selectObj[key] && selectObj[key].includes(item) ? fontColorPrimary : ''}} 
                                            key={index} 
                                            onClick={() => {toSelect(key, item)}}
                                          >
                                            {item}
                                          </div>
                                        )
                                      }
                                    })
                                  }
                                </div>
                              </div>
                            )
                          })
                        }
                        

                    </div>
                  </Spin>
                </div>
              )
            }
        </div>
      </div>
    </div>
    
  )
}

export default Hmcarsearch